import { RecipeSearch } from "./RecipeSearch";

export { RecipeSearch } from "./RecipeSearch";

export default RecipeSearch;
